import { useTypedSelector } from "@/config/configureAppStore";

/**
 * Resolves the signed-in user's email for display, Calendly prefill, payments, etc.
 * Uses `emailId` from `/user/state`, stored in `userSlice` after `fetchUserState`.
 */
export function useServerEmail(): string {
  return useTypedSelector((state) => state.user.emailId);
}
